<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<h1 class="c-modal__title c-text c-text--xl" *ngIf="vm.isInitialized">{{ 'Symptom_Check.Explain_Title' | translate }}</h1>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeConditionInfoButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pb" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div *ngIf="vm.isInitialized">
					<div class="o-grid o-grid--wrap u-ost-md">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-55@md-and-up u-no-p@up-to-md u-no-pl">
							<p class="c-text">{{ vm.condition?.condition?.common_name || vm.condition.common_name }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-85@sm-and-up o-grid__cell--w-35@md-and-up u-no-p@up-to-md">
							<item-progress [value]="vm.condition.probability" [max]="1"></item-progress>
						</div>
						<div class="o-grid__cell o-grid__cell--w-20 o-grid__cell--w-15@sm-and-up o-grid__cell--w-10@md-and-up u-no-pr">
							<p class="c-text c-text--right">{{ vm.condition.probability * 100 | number: '1.1-1' }}%</p>
						</div>
					</div>
					<div class="u-ost-xxl" *ngIf="vm.evidence?.supporting_evidence">
						<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Reasons_Supporting' | translate }}</h2>
						<ul class="c-list">
							<li class="c-list__item c-list-item" *ngFor="let evidence of vm.evidence.supporting_evidence">
								<div class="o-grid o-grid--center-v">
									<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
										<p class="c-text c-text--s9">
											<i class="o-icon o-icon--arrow-up" aria-hidden="true"></i>
										</p>
									</div>
									<div class="o-grid__cell o-grid__cell--slim u-no-pr">
										<p class="c-text">{{ evidence.common_name }}</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="u-ost-xxl" *ngIf="vm.evidence?.conflicting_evidence">
						<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Reasons_Conflicting' | translate }}</h2>
						<ul class="c-list">
							<li class="c-list__item c-list-item" *ngFor="let evidence of vm.evidence.conflicting_evidence">
								<div class="o-grid o-grid--center-v">
									<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
										<p class="c-text c-text--s3">
											<i class="o-icon o-icon--arrow-down" aria-hidden="true"></i>
										</p>
									</div>
									<div class="o-grid__cell o-grid__cell--slim u-no-pr">
										<p class="c-text">{{ evidence.common_name }}</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="u-ost-xxl" *ngIf="vm.evidence?.unconfirmed_evidence">
						<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Reasons_Unconfirmed' | translate }}</h2>
						<ul class="c-list">
							<li class="c-list__item c-list-item" *ngFor="let evidence of vm.evidence.unconfirmed_evidence">
								<p class="c-text">{{ evidence.common_name }}</p>
							</li>
						</ul>
					</div>
				</div>
				<loader-overlay *ngIf="!vm.isInitialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
